import { Toaster as Sonner } from 'sonner'
import { AssetIcon } from '@/shared/ui/Asset'

type ToasterProps = React.ComponentProps<typeof Sonner>

export const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position={'bottom-left'}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:px-4 group-[.toaster]:h-[56px] group-[.toaster]:bg-greyscale-500 group-[.toaster]:text-greyscale-100 group-[.toaster]:border-none group-[.toaster_[data-title]]:typo-body-1 group-[.toaster]:rounded-[8px] group-[.toaster]:shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] group-[.toaster]:gap-4 [&_[data-icon]]:size-6 [&_[data-icon]]:m-0',
        },
        style: {
          width: '367px',
        },
      }}
      icons={{
        success: <AssetIcon filename={'toast-success.png'} size={24} />,
        error: <AssetIcon filename={'toast-error.png'} size={24} />,
      }}
      {...props}
    />
  )
}
